import { motion, Variants } from 'framer-motion';
import { Backdrop } from './backdrop';

export interface ModalRef<T> {
  focus(props: T): void;
}

const ModalAnimation: Variants = {
  hidden: {
    y: '-100vh',
    opacity: 0,
  },
  visible: {
    y: '0',
    opacity: 1,
    transition: {
      duration: 0.1,
      type: 'spring',
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    y: '100vh',
    opacity: 0,
  },
};

interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
}

export const Modal: React.FC<ModalProps> = ({ children, onClose }) => {
  return (
    <Backdrop onClick={onClose}>
      <motion.div
        className="flex overflow-hidden"
        variants={ModalAnimation}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div className="relative flex justify-center items-center h-screen w-screen overflow-y-auto z-[50]">
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {children}
          </div>
        </div>
      </motion.div>
    </Backdrop>
  );
};
